import { hotItems } from '@/mocks/hot';

const heroChips = [
  { icon: 'ri-tv-2-line', text: '六大频道' },
  { icon: 'ri-refresh-line', text: '滚动速报' },
  { icon: 'ri-fire-line', text: '热榜排行' },
  { icon: 'ri-time-line', text: '事件脉络' },
];

export default function Hero() {
  const peek = hotItems.slice(0, 3);
  return (
    <section id="top" className="relative">
      <div className="mx-auto max-w-[1200px] px-4 pb-12 pt-10 md:px-6 md:pb-16 md:pt-14">
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute inset-0 dot-grid-light opacity-60" />
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-background-50/10 blur-2xl" />
          <div className="pointer-events-none absolute -bottom-28 -left-16 h-72 w-72 rounded-full bg-secondary-400/20 blur-3xl" />

          <div className="relative grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-3 py-1 text-sm font-semibold text-background-50 ring-1 ring-background-50/30">
                <span className="h-2 w-2 rounded-full bg-background-50 animate-livepulse" />
                实时速报 · 滚动更新中
              </span>

              <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-5xl">
                全网热点，一网打尽
                <br />
                <span className="text-secondary-300">实时吃料</span> 不漏关键节点
              </h1>

              <p className="mt-5 max-w-xl text-base leading-relaxed text-background-50/90 md:text-lg">
                紧盯全网娱乐、影视、综艺与社会动态，第一时间同步最新爆料与事件进展。滚动更新的即时内容速报，
                帮你掌握最新鲜的料，随时刷新看新瓜。
              </p>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
                <a
                  href="#feed"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition hover:-translate-y-0.5"
                >
                  开始实时追更
                  <i className="ri-arrow-right-line" />
                </a>
                <a
                  href="#hot"
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-6 py-3 text-sm font-semibold text-background-50 ring-1 ring-background-50/50 transition hover:bg-background-50/10"
                >
                  查看全网热榜
                  <i className="ri-bar-chart-line" />
                </a>
              </div>

              <div className="mt-9 flex flex-wrap gap-2.5">
                {heroChips.map((c) => (
                  <span
                    key={c.text}
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/12 px-3 py-1.5 text-xs font-medium text-background-50 ring-1 ring-background-50/20"
                  >
                    <i className={c.icon} style={{ fontSize: 14 }} />
                    {c.text}
                  </span>
                ))}
              </div>
            </div>

            <div className="hidden lg:block">
              <div className="overflow-hidden rounded-3xl bg-background-50/12 ring-1 ring-background-50/25 backdrop-blur-sm">
                <div className="flex items-center justify-between border-b border-background-50/15 px-5 py-3.5">
                  <span className="text-sm font-semibold text-background-50">此刻正在热聊</span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-background-50/80">
                    <span className="h-1.5 w-1.5 rounded-full bg-secondary-300 animate-livepulse" />
                    热度实时刷新
                  </span>
                </div>
                <div className="space-y-1 p-3">
                  {peek.map((item) => (
                    <a
                      key={item.id}
                      href="#hot"
                      className="group flex items-start gap-3 rounded-2xl px-3 py-3 transition hover:bg-background-50/10"
                    >
                      <span className="mt-0.5 grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-background-50/90 font-heading text-base text-primary-600">
                        {item.id}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="line-clamp-2 text-sm font-medium leading-snug text-background-50 group-hover:text-secondary-200">
                          {item.title}
                        </p>
                        <div className="mt-2 flex items-center justify-between gap-3">
                          <span className="text-[11px] text-background-50/70">{item.tag}</span>
                          <span className="text-[11px] font-semibold text-secondary-200">{item.heat}</span>
                        </div>
                      </div>
                    </a>
                  ))}
                  <div className="border-t border-background-50/15 px-3 pb-2 pt-3 text-center">
                    <span className="text-[11px] text-background-50/60">榜单实时更新 · 点击查看完整热榜</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}